import { useEffect, useState } from 'react';
import './news-view.styles.scss';
import { Link } from 'react-router-dom';
import { listenToNews } from '@/utils/getDataFromDb';
import { NewsItem } from './news-view.component';

// The latest game day's top league headlines, for My Team. Nothing until
// the league has news.
const NewsHeadlines = ({ league, teams, teamLink, gameLink, playerLink, highlightId, newsLink, count = 3 }) => {

    const [ latest, setLatest ] = useState(null);

    useEffect(() => {
        let unsub;
        listenToNews({ leagueId: league.id, limit: 1, callback: (d) => setLatest(d[0] ?? null), handleListener: (u) => { unsub = u; } });
        return () => { if (unsub) unsub(); };
    }, [league.id])

    const items = latest?.league?.slice(0, count) ?? [];
    if (!items.length) return null;

    return (
        <div className='g-card news-headlines'>
            <h3>Headlines</h3>
            <ul className='news-list'>
                {items.map(item => (
                    <NewsItem key={item.id} item={item} teams={teams} teamLink={teamLink} gameLink={gameLink} playerLink={playerLink} highlightId={highlightId} />
                ))}
            </ul>
            <Link to={newsLink} className='see-all'>All news</Link>
        </div>
    )
}

export default NewsHeadlines
